import { http } from 'vue'

export default {
  postRentPreRegistration (context, params = {}) {
    return http.post('rent_pre_registrations', params.data)
  },
  putRentPreRegistration (context, params = {}) {
    return http.put('rent_pre_registrations/' + params.id, params.data)
  },
  loadRentPreRegistration (context, params = {}) {
    return http.get('rent_pre_registrations/' + params.id + '?email=' + params.email)
  },
  loadRent (context, params = {}) {
    return http.get('rents/' + params.rentId)
  },
  loadRents (context, params = {}) {
    const pageParam = '&page=' + ((params.page) ? params.page : 1)
    const sortParam = '&sort=-id'
    const companyIdParam = (params.companyId) ? '&company_id=' + params.companyId : ''
    return http.get('rents?client_id=' + params.clientId + pageParam + sortParam + companyIdParam)
  },
  postRent (context, params = {}) {
    return http.post('rents', params.data)
  },
  saveRent (context, payload) {
    context.commit('SAVE_RENT', payload)
  },
  unsetRent (context, payload) {
    context.commit('UNSET_RENT', payload)
  },
  postRentStatus (context, params = {}) {
    return http.post('rent_status', params.data)
  },
  changeRentPreRegistration (context, payload) {
    context.commit('CHANGE_RENT_PRE_REGISTRATION', payload)
  },
  unsetRentPreRegistration (context) {
    context.commit('UNSET_RENT_PRE_REGISTRATION')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rents/actions.js